"use client";
import BlockHeader from "@/components/UIkit/BlockHeader";
import StudyFormatCardV2 from "./StudyFormatCardV2";
import StudyFormatCardVioletV2 from "./StudyFormatCardVioletV2";
import { ReactNode } from "react";
import { SerializedEditorState } from "@payloadcms/richtext-lexical/lexical";

export interface StudyFormatBlockProps {
  id?: string;
  title: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  formatList: Array<{
    title: ReactNode | SerializedEditorState;
    list: Array<string> | Array<{
      item: ReactNode | SerializedEditorState
    }>;
    subtitle: ReactNode | SerializedEditorState;
    txtContent: ReactNode | SerializedEditorState;
  }>;
  color?: "violet" | "blue" | "green";
  size?: "small" | "large";
}
export default function StudyFormatBlockV2({
  title,
  formatList,
  id,
  subtitle,
  color = "violet",
  size = "small",
}: StudyFormatBlockProps) {
  return (
    <div
      id={id}
      data-meta="StudyFormatBlockV2"
      className="container mx-auto sm:px-6 lg:px-8 my-14"
    >
      <BlockHeader title={title} subtitle={subtitle} />
      <div className="flex justify-center">
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 lg:gap-4 gap-4">
          {formatList.map((item, index) => {
            if (color === "violet" && size === "large") {
              return (
                <StudyFormatCardVioletV2
                  key={index}
                  subtitle={item.subtitle}
                  title={item.title}
                  list={item.list}
                  txtContent={item.txtContent}
                  index={index}
                  color={"violet"}
                />
              );
            }
            return (
              <StudyFormatCardV2
                key={index}
                subtitle={item.subtitle}
                title={item.title}
                txtContent={item.txtContent}
                index={index}
                color={color}
                list={item.list}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
